<template>
  <div>
    <header class="white">
      <div class="container">
        <a :href="data.link" target="_blank" class="header__logo">
          <img :src="require(`../assets/img/logo/orange/${data.logo}`)" :alt="data.name">
        </a>
      </div>
    </header>
  </div>
</template>

<script>
import Content from '../data/content.js'
let lang = process.env.VUE_APP_LOCALITY;

export default {
  data: function() {
    return {
      data: Content[lang].navbar,
    }
  },
};
</script>

<style>
header {
  position: relative;
}
header .container {
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 1;
  position: relative;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04), 0px 8px 12px -2px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
}

.header__logo {
  max-width: 163px;
  display: block;
  widtH: 100%;
}

.header__logo img {
  display: block;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  header .container {
    padding: 30px 0px 30px;
  }

  .header__logo {
    padding-left: 30px;
  }
}
</style>